"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.registerLocale2 = exports.DatePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _Icon = require("../../Elements/Icon/Icon");
var _TextInput = require("../TextInput/TextInput");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */

const DatePicker = ({
  hint,
  promptText,
  label,
  optionalText,
  onChange,
  dateFormat,
  selected,
  children,
  calendarContainer,
  onCalendarClose,
  onCalendarOpen,
  closeOnScroll,
  shouldCloseOnSelect,
  onChangeRaw,
  includeDates,
  includeDateIntervals,
  inline,
  locale,
  minDate,
  maxDate,
  strictParsing,
  tabIndex,
  calendarStartDay,
  onBlur,
  isSpecial,
  size,
  ...props
}) => {
  const [startDate, setStartDate] = (0, _react.useState)(null);
  const [isOpened, setIsOpened] = (0, _react.useState)(false);
  const CustomInput = /*#__PURE__*/(0, _react.forwardRef)(({
    onClick,
    value,
    ...args
  }, ref) => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)('ccl__form-datepicker-container', isOpened && 'opened'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
        className: "ccl__form-datepicker-input",
        onClick: onClick,
        value: value,
        promptText: promptText,
        ...props,
        ...args
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        className: "ccl__form-datepicker-icon",
        type: "calendar-month",
        onClick: onClick
      })]
    });
  });
  const calendarOpenEvent = () => {
    setIsOpened(true);
    if (onCalendarOpen) {
      onCalendarOpen();
    }
  };
  const calendarCloseEvent = () => {
    setIsOpened(false);
    if (onCalendarClose) {
      onCalendarClose();
    }
  };
  const changeEvent = date => {
    setStartDate(date);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)('ccl__form-datepicker-wrapper', size && `ccl__form-datepicker-size-${size}`, props.error && 'ccl__form-datepicker--has-error', props.disabled && 'ccl__form-datepicker--disabled'),
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl__form-datepicker-label",
        children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl__form-datepicker-optional",
          children: optionalText
        })]
      }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl__form-datepicker-hint",
        children: hint
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDatepicker.default, {
        selected: selected ? selected : startDate,
        calendarContainer: calendarContainer,
        onChange: isSpecial ? onChange : changeEvent
        // onChange={ changeEvent }
        ,
        customInput: /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomInput, {}),
        showPopperArrow: false,
        onCalendarOpen: calendarOpenEvent,
        onCalendarClose: calendarCloseEvent,
        placeholderText: promptText,
        dateFormat: dateFormat,
        closeOnScroll: closeOnScroll,
        shouldCloseOnSelect: shouldCloseOnSelect,
        onChangeRaw: onChangeRaw,
        inline: inline,
        locale: locale,
        strictParsing: strictParsing,
        tabIndex: tabIndex,
        minDate: minDate,
        maxDate: maxDate,
        onBlur: onBlur,
        includeDates: includeDates,
        includeDateIntervals: includeDateIntervals,
        calendarStartDay: calendarStartDay,
        disabled: props.disabled,
        showDisabledMonthNavigation: true,
        children: children
      })]
    })
  });
};
exports.DatePicker = DatePicker;
const registerLocale2 = exports.registerLocale2 = _reactDatepicker.registerLocale;
DatePicker.defaultProps = {
  label: 'Date picker',
  hint: 'Hint text goes in here',
  optionalText: '(optional)',
  promptText: 'MM/DD/YYYY',
  dateFormat: 'MM/dd/yyyy',
  closeOnScroll: false
};